/**
 * Utility functions for managing banner dismiss states in localStorage
 */

const BANNER_STORAGE_KEY_PREFIX = 'liscio_ai_banner_dismissed_';

/**
 * Get the localStorage key for a specific banner type
 * @param type - The banner type (e.g., 'message', 'file')
 * @returns The localStorage key for the banner type
 */
const getBannerStorageKey = (type: string): string =>
  `${BANNER_STORAGE_KEY_PREFIX}${type}`;
/**
 * Check if a banner has been dismissed by the user
 * @param type - The banner type to check
 * @returns True if the banner has been dismissed, false otherwise
 */
export const isBannerDismissed = (type: string): boolean => {
  try {
    const key = getBannerStorageKey(type);
    const dismissed = localStorage.getItem(key);
    return dismissed === 'true';
  } catch (error) {
    // If localStorage is not available, default to showing the banner
    console.warn('localStorage not available:', error);
    return false;
  }
};

/**
 * Mark a banner as dismissed
 * @param type - The banner type to dismiss
 */
export const dismissBanner = (type: string): void => {
  try {
    const key = getBannerStorageKey(type);
    localStorage.setItem(key, 'true');
  } catch (error) {
    console.warn('Failed to save banner dismiss state:', error);
  }
};
